<template>
  <div>
    <div class="page-header clear-filter">
      <parallax
        class="page-header-image"
        :style="
          isGeodidalab
            ? { 'background-image': 'url(' + imageUrlGeodidalab + ')' }
            : { 'background-image': 'url(' + imageUrlIstitutoMosso + ')' }
        "
      >
      </parallax>
      <div class="container">
        <div class="content-center brand py-4 titleBackground">
          <h1 class="h1-seo" v-if="isGeodidalab">GEODIDALAB</h1>
          <!--<h1 class="h1-seo" v-else>ISTITUTO MOSSO</h1>-->
          <h3 v-if="isGeodidalab">
            «se ascolto dimentico, se vedo ricordo, se faccio capisco…..»
          </h3>
          <h3 v-else>
            <img src="../assets/images/istitutomosso/Logo_Homepage_White.png"/>
          </h3>
        </div>
      </div>
    </div>
    <div class="main"></div>

    <div class="container mt-5 pb-0">
      <div class="text-center">
        <h4 v-if="isGeodidalab">{{ descriptionGeodidalab }}</h4>
        <!-- <h4 v-else>{{ descriptionIstitutoMosso }} </h4> -->
        <h5 v-else>
          <div v-for="(frase, index) in descriptionIstitutoMosso" :key="index">
            {{frase}}<br>
          </div></h5>
      </div>
    </div>
    <div class="section pt-lg-5 pt-2">
      <div class="text-center justify-content-center">
        <div class="card-group justify-content-center">
          <div v-for="item in cardObject" :key="item.title">
            <card :item="item"></card>
            <!--v-if="item.title !== 'Percorsi' || isGeodidalab && item.title === 'Percorsi'" -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Parallax } from "@/components";
import card from "../components/customComponents/card";
import Vue from "vue";
import VueImg from "v-img";
import { config } from "@/utils/config";

const vueImgConfig = {
  // Use `alt` attribute as gallery slide title
  altAsTitle: true,
  // Display 'download' button near 'close' that opens source image in new tab
  sourceButton: false,
  // Event listener to open gallery will be applied to <img> element
  openOn: "click",
  // Show thumbnails for all groups with more than 1 image
  thumbnails: true,
};
Vue.use(VueImg, vueImgConfig);

require("@/assets/images/canoe-scaled.jpg.webp");

export default {
  name: "index",
  bodyClass: "index-page",
  components: {
    Parallax,
    card,
  },

  data() {
    return {
      cardObject: [
        {
          title: "La storia",
          message: "Questa è la card 1",
          imgSrc: require("@/assets/images/timeline.jpg"),
          pageDestination: "/elencotimeline",
          pageDestinationIstitutoMosso: "/elencotimeline",
        },
        {
          title: "Itinerari",
          message: "Questa è la card 2",
          imgSrc: require("@/assets/images/percorsi.jpg"),
          pageDestination: "/percorsi",
          pageDestinationIstitutoMosso: "/elencoPercorsi",
        },
        {
          title: "Attività",
          message: "Questa è la card 3",
          imgSrc: require("@/assets/images/esperimenti.jpg"),
          pageDestination: "/esperimenti",
          pageDestinationIstitutoMosso: "/esperimenti",
        },
        {
          title: "Strumenti",
          message: "Questa è la card 4",
          imgSrc: require("@/assets/images/strumenti.jpg"),
          pageDestination: "/strumenti",
          pageDestinationIstitutoMosso: "/strumenti",
        },
      ],
      descriptionGeodidalab:
        "Il GeoDidaLab è un laboratorio di educazione\n" +
        "ambientale e ricerca didattica gestito dal\n" +
        "Dipartimento di Scienze della Terra\n" +
        "dell’Università di Torino che dal 2013 propone\n" +
        "attività didattiche per le scuole di ogni ordine\n" +
        "e grado, attività di formazione per gli\n" +
        "insegnanti e promuove progetti di ricerca\n" +
        "scientifica in ambito geologico-ambientale e\n" +
        "didattico.",
      descriptionIstitutoMosso: ["\"Per gli studi severi\n", "per l'esperimento sagace\n", "per la pace e per la vita\n", "Nella maestà delle Alpi\n", "ANGELO MOSSO\n",  "Creava e donava\n", "questa serena dimora\n", "agli allievi suoi\n", "a quelli che ancora\n", "non erano\""],
      // descriptionIstitutoMosso:
      //   "Per gli studi severi\n" +
      //   "per l'esperimento sagace\n" +
      //   "per la pace e per la vita\n" +
      //   "Nella maestà delle Alpi\n" +
      //   "ANGELO MOSSO\n" +
      //   "Creava e donava\n" +
      //   "questa serena dimora\n" +
      //   "agli allievi suoi\n" +
      //   "a quelli che ancora\n" +
      //   "non erano",
      imageUrlGeodidalab: require("../assets/images/canoe-scaled.jpg.webp"),
      imageUrlIstitutoMosso: require("../assets/images/istitutomosso/istitutoMossoIndex.jpg"),

      isGeodidalab: true,
    };
  },

  mounted() {
    this.isGeodidalab = config.isGeodidalab;
  },
};
</script>
<style>
.titleBackground {
  background-color: rgba(0, 0, 0, 0.5);
}
</style>
